// @ts-strict-ignore
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { ArticleUsageUtils } from '@article/util/article-usage-utils';
import { ArticleUsageInfoPropertyDef } from '@article/constants/article-usage-info-property-def';
import { NumberUtils } from '@shared/util/number-utils';
import { ArticleVO } from '@article/model/vo/article.vo';
import { DrillingHoleRange } from '@3d-scene/model3d/util/drillinghole/drilling-hole-size';
import { DrillingHoleUtils } from '@3d-scene/model3d/util/drillinghole/drilling-hole-utils';
import { MathUtils } from '@3d-scene/common/util/math-utils';
import { AlertButton } from '@shared/alert/alertButton';
import { ConnectionAreaVO } from '@shared/vo/meta-element.vo';
import { RangeOnLineConnectionTypeDef } from '../constants/range-on-line-connection-type-def';
import { Connection } from '@3d-scene/model3d/connection';
import { MetaElementUsageUtils } from '../util/meta-element-usage-utils';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { ArticleUtils } from '@article/util/article-utils';
import { MountingRailHelper } from '../helper/mounting-rail.helper';
import { AlertHelper } from '@shared/alert/alert.helper';
import { Injectable } from '@angular/core';
import { ConnectionInfoUtils } from '@3d-scene/model3d/util/connection-info-utils';

@Injectable({ providedIn: 'root' })
export class LoadProjectDrillingHolesService {
  constructor(
    private mountingRailHelper: MountingRailHelper,
    private alertHelper: AlertHelper,
    private containerService: ContainerService
  ) {}

  public checkStartDrillingHolePosition(): void {
    const mountingRailContainer: ArticleContainer = this.mountingRailHelper.getMountingRailContainer();
    if (!mountingRailContainer) {
      return;
    }

    const hasPreset: boolean = ArticleUsageUtils.getArticleUsageInfoPropertyBooleanValue(
      mountingRailContainer.articleUsage,
      ArticleUsageInfoPropertyDef.HAS_DRILLINGHOLE_PRESET
    );
    if (!hasPreset) {
      return;
    }

    const drillingHoleOffset: number = ArticleUsageUtils.getArticleUsageInfoPropertyFloatValue(
      mountingRailContainer.articleUsage,
      ArticleUsageInfoPropertyDef.DRILLINGHOLE_PRESET_OFFSET
    );
    const drillingHoleDistance: number = ArticleUsageUtils.getArticleUsageInfoPropertyFloatValue(
      mountingRailContainer.articleUsage,
      ArticleUsageInfoPropertyDef.DRILLINGHOLE_PRESET_DISTANCE
    );
    if (NumberUtils.isNotNumber(drillingHoleOffset) || NumberUtils.isNotNumber(drillingHoleDistance)) {
      return;
    }

    const drillingHole: ArticleVO = this.findDrillingHole(mountingRailContainer);
    const startDrillingHoleRange: DrillingHoleRange = DrillingHoleUtils.getStartDrillingHolePositionByArticle(drillingHole, drillingHoleDistance);
    if (startDrillingHoleRange) {
      if (
        MathUtils.compare(drillingHoleOffset, startDrillingHoleRange.min) < 0 ||
        MathUtils.compare(drillingHoleOffset, startDrillingHoleRange.max) > 0
      ) {
        this.alertHelper.showAlert('global.title.information', 'load.message.invalid_start_drilling_hole_position', null, [AlertButton.OK]);
      }
    }
  }

  private findDrillingHole(mountingRail: ArticleContainer): ArticleVO {
    if (!mountingRail || !mountingRail.article) {
      return null;
    }
    const acceptingConnectionArea: ConnectionAreaVO = ConnectionInfoUtils.findRangeOnLineConnectionByType(
      mountingRail.article.metaElements,
      RangeOnLineConnectionTypeDef.TYPE_DRILLING_HOLE
    );
    if (!acceptingConnectionArea) {
      return null;
    }

    const acceptingConnection: Connection = mountingRail.findConnection(acceptingConnectionArea.name);
    if (!acceptingConnection) {
      return null;
    }

    const forwardUsageIds: string[] = MetaElementUsageUtils.forwardConnectedArticleUsageIds(acceptingConnection.metaElementUsage);
    for (const forwardId of forwardUsageIds) {
      const forwardContainer: ArticleContainer = this.containerService.findArticleContainerInGlobal(forwardId);
      if (forwardContainer && ArticleUtils.isDrillingHole(forwardContainer.article)) {
        return forwardContainer.article;
      }
    }
    return null;
  }
}
